import React, { useRef, useState } from 'react';
import { Button, PageEmptyState, ScrollToTopButton } from 'seagull';
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useStoreActions } from "../../../contexts";
import { useOnMount } from "../../../hooks/useOnMount";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import ActivityLogItem from "../../../components/ActivityLogItem/ActivityLogItem";
import ActivityErrorIcon from "./icons/activity-error.svg";
import { useAppConfig } from "../../../store/store-context";
function ActivityLog(props) {
  const {
    agreement,
    activityLogEntries
  } = props;
  const {
    logBI
  } = useStoreActions();
  const {
    scrollBehavior
  } = useAppConfig();
  const vendorName = "".concat(agreement.seller.firstName, " ").concat(agreement.seller.lastName);
  const clientName = "".concat(agreement.buyer.firstName, " ").concat(agreement.buyer.lastName);
  const containerRef = useRef(null);
  const [scrollContainer, setScrollContainer] = useState();
  useOnMount(() => {
    logBI(10574);
    if (containerRef.current) {
      const node = containerRef.current.closest('[data-testid="minisite-page"]');
      if (node) {
        setScrollContainer(node);
      }
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "activity-page-page-header"
  }, /*#__PURE__*/React.createElement(MinisiteTabHeader, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "activity-content"
  }, activityLogEntries.map((logItem, idx) => /*#__PURE__*/React.createElement(ActivityLogItem, {
    isFirst: idx === 0,
    isLast: idx === activityLogEntries.length - 1,
    key: logItem.id(),
    vendorName: vendorName,
    clientName: clientName,
    entry: logItem,
    relationship: agreement
  }))), /*#__PURE__*/React.createElement(ScrollToTopButton, {
    "data-testid": "activity-scroll-to-top-btn",
    scrollContainer: scrollContainer,
    scrollBehavior: scrollBehavior
  })));
}
export default function WrappedActivityLog(_ref) {
  let {
    agreement
  } = _ref;
  const {
    fetchActivityLog
  } = useStoreActions();
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => fetchActivityLog(agreement.id),
    getStoreLocation: state => state.activityLog[agreement.id],
    renderChild: _ref2 => {
      let {
        data,
        loading,
        refresh
      } = _ref2;
      return /*#__PURE__*/React.createElement(ActivityLog, {
        agreement: agreement,
        activityLogEntries: data,
        isRefreshing: loading,
        refresh: refresh
      });
    },
    renderError: _ref3 => {
      let {
        refresh
      } = _ref3;
      return /*#__PURE__*/React.createElement(PageEmptyState, {
        illustration: /*#__PURE__*/React.createElement(ActivityErrorIcon, null),
        message: "Couldn't load the activity log",
        actions: /*#__PURE__*/React.createElement(Button, {
          onClick: () => refresh(),
          "data-testid": "activity-error-refresh-btn"
        }, "Try again")
      });
    }
  });
}